import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import PublicLayout from './components/PublicLayout';
import ProtectedRoute from './components/ProtectedRoute';
import SongsPage from './pages/SongsPage';
import SetListsPage from './pages/SetListsPage';
import SetListViewPage from './pages/SetListViewPage';
import ShowsPage from './pages/ShowsPage';
import SettingsPage from './pages/SettingsPage';
import PublicHomePage from './pages/PublicHomePage';
import AboutPage from './pages/AboutPage';
import MusicPage from './pages/MusicPage';
import ContactPage from './pages/ContactPage';

const AppContent = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    // Authenticated users see the songbank app
    return (
      <Layout>
        <Routes>
          <Route path="/" element={<ProtectedRoute><SongsPage /></ProtectedRoute>} />
          <Route path="/songs" element={<ProtectedRoute><SongsPage /></ProtectedRoute>} />
          <Route path="/setlists" element={<ProtectedRoute><SetListsPage /></ProtectedRoute>} />
          <Route path="/setlists/:id" element={<ProtectedRoute><SetListViewPage /></ProtectedRoute>} />
          <Route path="/shows" element={<ProtectedRoute><ShowsPage /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
          {/* Redirect any public routes to songbank when authenticated */}
          <Route path="/about" element={<ProtectedRoute><SongsPage /></ProtectedRoute>} />
          <Route path="/music" element={<ProtectedRoute><SongsPage /></ProtectedRoute>} />
          <Route path="/contact" element={<ProtectedRoute><SongsPage /></ProtectedRoute>} />
        </Routes>
      </Layout>
    );
  }

  // Unauthenticated users see the public site
  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<PublicHomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/music" element={<MusicPage />} />
        <Route path="/contact" element={<ContactPage />} />
        {/* Redirect songbank routes to home when not authenticated */}
        <Route path="/songs" element={<PublicHomePage />} />
        <Route path="/setlists" element={<PublicHomePage />} />
        <Route path="/shows" element={<PublicHomePage />} />
      </Routes>
    </PublicLayout>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;